<template>
    <div class="ce">
        <!-- Confettis CSS : le moment de récompense, sans canvas ni boucle JS. -->
        <div class="ce-confettis" aria-hidden="true">
            <span v-for="n in 14" :key="n" :class="'ce-c' + n"></span>
        </div>

        <header class="ce-header">
            <div class="ce-brand">
                <i class="ri-restaurant-2-line"></i>
                <h1>{{ restaurantNom || 'Notre carte' }}</h1>
            </div>
            <div v-if="tableLabel" class="ce-table">{{ tableLabel }}</div>
        </header>

        <main class="ce-main">
            <!-- ============ CÉLÉBRATION ============ -->
            <div class="ce-fete">
                <div class="ce-check">
                    <i class="ri-check-line"></i>
                </div>
                <h2 class="ce-titre">C'est parti !<br>Votre commande est en cuisine.</h2>
                <p class="ce-sous">Le serveur vous l'apporte dès qu'elle est prête.</p>
            </div>

            <!-- ============ RÉCAPITULATIF ============ -->
            <div class="ce-carte">
                <div class="ce-carte-haut">
                    <span class="ce-ref">Commande #{{ orderRef }}</span>
                    <span class="ce-total">{{ fmt(lastOrder.total) }}</span>
                </div>
                <div class="ce-carte-bas">
                    <span><i class="ri-shopping-basket-2-line"></i> {{ lastOrder.count }} article{{ lastOrder.count > 1 ? 's' : '' }}</span>
                    <span v-if="tableLabel"><i class="ri-hashtag"></i> {{ tableLabel }}</span>
                </div>
            </div>

            <!-- ============ SUIVI ============ -->
            <section class="ce-suivi">
                <h3>Suivi de votre commande</h3>
                <div class="ce-steps">
                    <div class="ce-step done">
                        <span class="ce-dot"><i class="ri-check-line"></i></span>
                        <div>
                            <span class="ce-step-nom">Reçue</span>
                            <span class="ce-step-desc">La cuisine a validé votre commande</span>
                        </div>
                    </div>
                    <div class="ce-step encours">
                        <span class="ce-dot"><span class="ce-pulse"></span></span>
                        <div>
                            <span class="ce-step-nom">En préparation</span>
                            <span class="ce-step-desc">Le chef s'occupe de vos plats</span>
                        </div>
                    </div>
                    <div class="ce-step">
                        <span class="ce-dot"></span>
                        <div>
                            <span class="ce-step-nom">Servie</span>
                            <span class="ce-step-desc">Bientôt à votre table !</span>
                        </div>
                    </div>
                </div>
            </section>
        </main>

        <footer class="ce-cta">
            <button class="ce-btn" @click="$emit('nouvelle-commande')">
                Ajouter d'autres plats <i class="ri-add-circle-line"></i>
            </button>
        </footer>
    </div>
</template>

<script>
    /* eslint-disable */
    import { fmt } from "./format";

    export default {
        name: "commandeenvoyee",
        props: {
            orderRef: { type: String, default: "" },
            lastOrder: { type: Object, default: () => ({ total: 0, count: 0 }) },
            tableLabel: { type: String, default: "" },
            restaurantNom: { type: String, default: "" },
        },
        emits: ["nouvelle-commande"],
        methods: { fmt },
    };
</script>

<style scoped>
    /* eslint-disable */
    .ce { position: relative; display: flex; flex-direction: column; min-height: 100vh; overflow: hidden; }

    /* ---------- En-tête ---------- */
    .ce-header {
        display: flex; align-items: center; justify-content: space-between; gap: var(--sp-xs);
        padding: var(--sp-md) var(--sp-pad);
    }
    .ce-brand { display: flex; align-items: center; gap: var(--sp-xs); min-width: 0; }
    .ce-brand > i { font-size: 1.6rem; color: var(--c-primary); }
    .ce-brand h1 {
        margin: 0; font-size: 20px; line-height: 26px; font-weight: 800; letter-spacing: -0.01em;
        color: var(--c-primary); white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    }
    .ce-table {
        flex-shrink: 0; background: var(--c-surface-container); color: var(--c-primary);
        font-size: 13px; font-weight: 700; padding: 6px 14px; border-radius: 999px;
    }

    .ce-main { flex: 1; padding: var(--sp-xs) var(--sp-pad) 132px; position: relative; z-index: 2; }

    /* ---------- Célébration ---------- */
    .ce-fete { display: flex; flex-direction: column; align-items: center; text-align: center; padding: var(--sp-lg) 0 var(--sp-xl); }
    .ce-check {
        position: relative;
        width: 104px; height: 104px; border-radius: 999px; margin-bottom: var(--sp-lg);
        background: rgba(27, 170, 92, 0.12); color: var(--c-success);
        display: flex; align-items: center; justify-content: center; font-size: 3.4rem;
        animation: ce-pop 0.65s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
    .ce-check::after {
        content: ""; position: absolute; inset: 0; border-radius: 999px;
        border: 2px solid var(--c-success); opacity: 0; animation: ce-onde 1.4s ease-out 0.3s;
    }
    @keyframes ce-pop { 0% { transform: scale(0); } 100% { transform: scale(1); } }
    @keyframes ce-onde {
        0% { transform: scale(1); opacity: 0.6; }
        100% { transform: scale(1.6); opacity: 0; }
    }
    .ce-titre {
        margin: 0 0 var(--sp-xs); font-size: 30px; line-height: 38px;
        font-weight: 800; letter-spacing: -0.02em; color: var(--c-on-surface);
    }
    .ce-sous { margin: 0; font-size: 16px; line-height: 24px; color: var(--c-on-surface-variant); }

    /* ---------- Récapitulatif ---------- */
    .ce-carte {
        background: var(--c-surface); border: 1px solid var(--c-outline-variant);
        border-radius: 16px; padding: var(--sp-md); margin-bottom: var(--sp-xl);
    }
    .ce-carte-haut {
        display: flex; align-items: center; justify-content: space-between; gap: var(--sp-xs);
        padding-bottom: var(--sp-md); border-bottom: 1px solid var(--c-outline-variant);
    }
    .ce-ref {
        font-size: 12px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
        color: var(--c-on-surface-variant); font-variant-numeric: tabular-nums;
    }
    .ce-total {
        font-size: 20px; font-weight: 800; color: var(--c-primary); font-variant-numeric: tabular-nums;
    }
    .ce-carte-bas {
        display: flex; align-items: center; justify-content: space-between;
        padding-top: var(--sp-md); font-size: 15px; color: var(--c-on-surface-variant);
    }
    .ce-carte-bas span { display: flex; align-items: center; gap: 6px; }
    .ce-carte-bas i { font-size: 1.05rem; }

    /* ---------- Suivi ---------- */
    .ce-suivi h3 {
        margin: 0 0 var(--sp-lg); font-size: 18px; font-weight: 700; color: var(--c-on-surface);
    }
    .ce-steps { position: relative; padding-left: 38px; }
    .ce-steps::before {
        content: ""; position: absolute; left: 12px; top: 12px; bottom: 24px;
        width: 2px; background: var(--c-outline-variant);
    }
    .ce-step { position: relative; margin-bottom: var(--sp-xl); }
    .ce-step:last-child { margin-bottom: 0; }
    .ce-step > div { display: flex; flex-direction: column; }
    .ce-dot {
        position: absolute; left: -38px; top: 0; width: 26px; height: 26px;
        border-radius: 999px; background: var(--c-outline-variant);
        border: 4px solid var(--c-bg);
        display: flex; align-items: center; justify-content: center;
        color: #fff; font-size: 0.85rem;
    }
    .ce-step.done .ce-dot { background: var(--c-success); }
    .ce-step.encours .ce-dot { background: var(--c-primary); }
    .ce-pulse {
        width: 8px; height: 8px; border-radius: 999px; background: #fff;
        animation: ce-clign 1.4s ease-in-out infinite;
    }
    @keyframes ce-clign { 0%, 100% { opacity: 1; } 50% { opacity: 0.35; } }
    .ce-step-nom { font-size: 16px; font-weight: 700; color: var(--c-on-surface-variant); }
    .ce-step.done .ce-step-nom { color: var(--c-success); }
    .ce-step.encours .ce-step-nom { color: var(--c-primary); }
    .ce-step:not(.done):not(.encours) { opacity: 0.5; }
    .ce-step-desc { font-size: 13px; line-height: 18px; color: var(--c-on-surface-variant); }

    /* ---------- Bouton ---------- */
    .ce-cta {
        position: fixed; left: 0; right: 0; bottom: 0; z-index: 50;
        padding: var(--sp-md) var(--sp-pad) calc(var(--sp-lg) + env(safe-area-inset-bottom, 0px));
        background: var(--c-bg);
        background: color-mix(in srgb, var(--c-bg) 92%, transparent);
        backdrop-filter: blur(14px); -webkit-backdrop-filter: blur(14px);
    }
    .ce-btn {
        width: 100%; height: 56px; border: none; border-radius: 999px; cursor: pointer;
        background: var(--c-primary); color: #fff; font-family: inherit;
        font-size: 16px; font-weight: 700;
        display: flex; align-items: center; justify-content: center; gap: var(--sp-xs);
        box-shadow: 0 6px 18px rgba(255, 48, 8, 0.3); transition: transform 0.12s;
    }
    .ce-btn:active { transform: scale(0.98); }

    /* ---------- Confettis ---------- */
    .ce-confettis { position: absolute; inset: 0; z-index: 1; pointer-events: none; overflow: hidden; }
    .ce-confettis span {
        position: absolute; top: -24px; width: 9px; height: 14px; border-radius: 2px;
        opacity: 0; animation: ce-tombe 2.6s ease-in forwards;
    }
    @keyframes ce-tombe {
        0% { transform: translateY(0) rotate(0deg); opacity: 0; }
        10% { opacity: 1; }
        100% { transform: translateY(105vh) rotate(540deg); opacity: 0; }
    }
    .ce-c1  { left: 6%;  background: var(--c-primary);  animation-delay: 0.05s; }
    .ce-c2  { left: 14%; background: var(--c-success);  animation-delay: 0.35s; }
    .ce-c3  { left: 22%; background: var(--c-accent-warm); animation-delay: 0.15s; }
    .ce-c4  { left: 30%; background: var(--c-primary);  animation-delay: 0.55s; }
    .ce-c5  { left: 38%; background: var(--c-surface-high); animation-delay: 0.25s; }
    .ce-c6  { left: 46%; background: var(--c-success);  animation-delay: 0.65s; }
    .ce-c7  { left: 54%; background: var(--c-primary);  animation-delay: 0.1s; }
    .ce-c8  { left: 62%; background: var(--c-accent-warm); animation-delay: 0.45s; }
    .ce-c9  { left: 70%; background: var(--c-success);  animation-delay: 0.2s; }
    .ce-c10 { left: 78%; background: var(--c-primary);  animation-delay: 0.6s; }
    .ce-c11 { left: 86%; background: var(--c-surface-high); animation-delay: 0.3s; }
    .ce-c12 { left: 92%; background: var(--c-accent-warm); animation-delay: 0.5s; }
    .ce-c13 { left: 10%; background: var(--c-primary);  animation-delay: 0.8s; }
    .ce-c14 { left: 66%; background: var(--c-success);  animation-delay: 0.75s; }

    @media (prefers-reduced-motion: reduce) {
        .ce-confettis { display: none; }
        .ce-check, .ce-check::after, .ce-pulse { animation: none; }
    }
</style>
